import { useTranslation } from 'next-i18next'

import DropdownMenu from '~/components/DropdownMenu/DropdownMenu'
import MultiSelect from '~/components/MultiSelect'
import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { FieldError } from '~/components/FieldError'
import { GradeLevel } from '~/types/booking'

export default function GradeLevels(): React.ReactElement {
  const { t } = useTranslation(['studentPanel', 'booking'])
  const { fields, errors, setFields } = useSettingsFormContext()

  const dropdownMenuHeader = t('studentPanel:settings.labelGradeLevels')
  const selectedStateLabel = fields.gradeLevels?.map((elem) => t(`booking:gradeLevels.${elem}` as const)).join(', ')

  const handleOnClick = (item: GradeLevel): void => {
    setFields((prevState) => {
      const prevItems: GradeLevel[] = prevState.gradeLevels ?? []

      return {
        ...prevState,
        gradeLevels: !prevItems.includes(item) ? [...prevItems, item] : prevItems.filter((elem) => elem !== item),
      }
    })
  }

  const items = Object.values(GradeLevel).map((elem) => ({
    value: elem,
    label: t(`booking:gradeLevels.${elem}`),
  }))

  return (
    <div>
      <DropdownMenu header={dropdownMenuHeader} selectedStateLabel={selectedStateLabel}>
        <div className="space-y-1">
          <span className="text-xxs text-gray-light-fade leading-3">
            {t('studentPanel:settings.descriptionGradeLevels')}
          </span>
          <MultiSelect handleOnClick={handleOnClick} items={items} state={fields.gradeLevels ?? []} />
        </div>
      </DropdownMenu>
      <FieldError error={errors.gradeLevels} />
    </div>
  )
}
